import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";
import { IGalleryCategory } from "./types";
import { GALLERY_ROUTES } from "./routes";

export const fetchGetGallery = createAsyncThunk<IGalleryCategory[]>(
  "gallery/fetchGetGallery",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(GALLERY_ROUTES.GET_GALLERY);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
